// src/services/authService.js
import axios from 'axios';

const API_BASE_URL = 'https://playinbyd.com/api';
const APP_KEY = 'SgRTXsywVmWteEBLlYWecwgbDiHwlh';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authService = {
  // Register User
  async register(userData) {
    const payload = {
      app_key: APP_KEY,
      env_type: 'Prod',
      mobile: userData.mobile,
      password: userData.password,
      username: userData.username,
      security_pin: userData.security_pin,
      refer_code: userData.refer_code || ''
    };

    try {
      const response = await api.post('/api-user-registration', payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Login User
  async login(credentials) {
    const payload = {
      mobile: credentials.mobile,
      password: credentials.password,
      app_key: APP_KEY,
      env_type: 'Prod',
      device_id: credentials.device_id || 'web-browser-' + Date.now()
    };

    try {
      const response = await api.post('/api-user-login', payload);
      const data = response.data;
      
      // Store token and user data if login successful
      if (data.success && data.unique_jwt_token) {
        localStorage.setItem('authToken', data.unique_jwt_token);
        localStorage.setItem('userData', JSON.stringify({
          user_name: data.user_name,
          mobile: data.mobile,
          mobile_no: data.mobile_no,
          betting_status: data.betting_status,
          notification_status: {
            other: data.other_notification_status,
            main_game: data.main_game_notification_status,
            gali_disswar: data.gali_disswar_game_notification_status,
            starline: data.starline_game_notification_status
          }
        }));
      }
      
      return data;
    } catch (error) {
      console.error('Login API Error:', error.response || error);
      throw error.response?.data || { message: 'Login failed' };
    }
  },

  // Get lobby data
  async getLobbyData() {
    const token = this.getToken();
    
    if (!token) {
      throw new Error('No authentication token found');
    }

    const payload = {
      app_key: APP_KEY,
      env_type: 'Prod',
      unique_jwt_token: token
    };

    try {
      const response = await api.post('/api-lobby-data', payload, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      });
      
      // Update user data if received new information
      if (response.data.success && response.data.user_data) {
        this.updateUserData(response.data.user_data);
      }
      
      return response.data;
    } catch (error) {
      console.error('Lobby API Error:', error.response || error);
      throw error.response?.data || { message: 'Failed to fetch lobby data' };
    }
  },

  // Get dashboard data
  async getDashboardData() {
    const token = this.getToken();
    
    if (!token) {
      throw new Error('No authentication token found');
    }

    const payload = {
      app_key: APP_KEY,
      env_type: 'Prod',
      unique_jwt_token: token
    };

    try {
      const response = await api.post('/api-get-dashboard-data', payload);
      return response.data;
    } catch (error) {
      console.error('Dashboard API Error:', error.response || error);
      throw error.response?.data || { message: 'Failed to fetch dashboard data' };
    }
  },

  // Logout User
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
      sessionStorage.clear(); // 🔥 add this
    window.location.href = '/login';
  },

  // Check if user is authenticated
  isAuthenticated() {
    return !!this.getToken();
  },

  // Get JWT token
  getToken() {
    return localStorage.getItem('authToken');
  },

  // Get current user data
  getCurrentUser() {
    const userData = localStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  },

  // Update user data in localStorage
  updateUserData(userData) {
    const currentUserData = this.getCurrentUser() || {};
    const updatedUserData = { ...currentUserData, ...userData };
    localStorage.setItem('userData', JSON.stringify(updatedUserData));
    return updatedUserData;
  },

  // Add Authorization header to requests
  getAuthHeader() {
    const token = this.getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  }
};